"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BUTTON_VARIANT_NAMES = exports.BUTTON_SIZE_NAMES = void 0;
/** Names of button variants */

var BUTTON_VARIANT_NAMES = ["primaryBlack", "primaryWhite", "secondaryGray", "secondaryOutline", "noOutline"];
/** Name of treatments */

exports.BUTTON_VARIANT_NAMES = BUTTON_VARIANT_NAMES;
/** Names of button sizes */

var BUTTON_SIZE_NAMES = ["small", "medium", // DEPRECATED
"large"];
/** Available sizes */

exports.BUTTON_SIZE_NAMES = BUTTON_SIZE_NAMES;